import { INavigationConfig } from '~/src/dash/views/common';

export const audienceSegmentsNavigationConfig: INavigationConfig = {
  tabs: [
    { key: 'Segments', label: 'Segments', value: 0 },
    { key: 'Partners', label: 'Partners', value: 1 },
  ],
  defaultState: {
    activeTabIndex: 0,
  },
};
